import { Anchor } from '@components/atoms/Anchor';
import BREAKPOINTS from '@lib/constants/breakpoints';
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

const GridList = styled.ul<{ deskTemplate?: string; mobileTemplate?: string }>`
  margin: 32px 0;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: ${(props) => props.deskTemplate || '1fr 1fr 1fr'};

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    grid-template-columns: ${(props) => props.mobileTemplate || '1fr'};
  }

  &&& {
    list-style: none;
    padding: 0;

    li {
      margin: 0;
    }
  }
`;

const GridLinkList = ({
  deskTemplate,
  mobileTemplate,
  links,
  textAlign,
  prefetch = false,
}: {
  deskTemplate?: string;
  mobileTemplate?: string;
  links: { path: string; label: string }[];
  textAlign?:
    | 'center'
    | 'end'
    | 'justify'
    | 'left'
    | 'match-parent'
    | 'right'
    | 'start';
  prefetch?: boolean;
}) => (
  <GridList
    style={{ textAlign }}
    mobileTemplate={mobileTemplate}
    deskTemplate={deskTemplate}
  >
    {links.map((link) => (
      <li key={link.path}>
        <Link passHref href={link.path} prefetch={prefetch}>
          <Anchor>{link.label}</Anchor>
        </Link>
      </li>
    ))}
  </GridList>
);

export default GridLinkList;
